import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './style.scss';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Input from '../../ui/Input';
import Button from '../../ui/Button';
import PlusIcon from '../../assets/icons/plus.svg';
import RemoveIcon from '../../assets/icons/close.svg';
import { useValidator } from '../../hooks/formValidator/useValidator';
import { hasMinLength, hasOnlyAllowedCharacters, isNotEmpty, isUnique, } from '../../hooks/formValidator/validators';
const PLAYER_NAME_ALLOWED_CHARACTERS_REGEX = /^[\p{L}\p{N} _\-.]+$/u;
const MAX_PLAYERS_NUMBER = 20;
export const MIN_GAME_PLAYER_NAME_LENGTH = 3;
const formValidationSchema = {
    playerName: [
        isNotEmpty,
        isUnique,
        hasOnlyAllowedCharacters,
        hasMinLength(MIN_GAME_PLAYER_NAME_LENGTH),
    ],
};
const GamePlayersModule = ({ isTeamRally, onPlayersChange, onError, }) => {
    const { t } = useTranslation();
    const [players, setPlayers] = useState([]);
    const { formErrors, validateInputField } = useValidator({ inputSchema: formValidationSchema });
    const [formData, setFormData] = useState({ playerName: '' });
    const rallyPlayersNumber = isTeamRally ? MAX_PLAYERS_NUMBER : 1;
    const addPlayer = () => {
        const isErrors = validateInputField({
            fieldName: 'playerName',
            value: formData.playerName,
            context: {
                existingValues: players.map((player) => player.playerName),
                translationKey: 'player_name',
                allowedCharsRegex: PLAYER_NAME_ALLOWED_CHARACTERS_REGEX,
            },
        });
        if (isErrors) {
            onError(true);
        }
        else {
            onError(false);
            setPlayers([
                ...players,
                {
                    playerName: formData.playerName.trim(),
                    isTeamLeader: players.length === 0,
                },
            ]);
            formData.playerName = '';
        }
    };
    const removePlayer = (index) => {
        if (index === 0) {
            return;
        }
        setPlayers(players.filter((_, i) => i !== index));
    };
    useEffect(() => {
        onPlayersChange(players);
    }, [players]);
    return (_jsxs("div", { className: "rally-players", children: [!!players.length && (_jsx("div", { className: "players-list", children: players.map((player, index) => (_jsx("div", { className: 'player-item', children: _jsx(Input, { id: player.playerName, value: player.playerName, color: 'gray', placeholder: t('placeholder.player_name'), readOnly: true, tabIndex: -1, style: { pointerEvents: 'none' }, additionalContent: _jsx("div", { className: "player-control", children: _jsx(Button, { shape: 'square', icon: _jsx(RemoveIcon, {}), iconSize: 'small', onClick: () => removePlayer(index), disabled: index === 0 }) }) }) }, player.playerName))) })), players.length < rallyPlayersNumber && (_jsx("div", { className: 'player-item item--new-player', children: _jsx(Input, { name: 'playerName', error: !!formErrors.playerName?.length, errorMessage: !!formErrors.playerName?.length
                        ? t(formErrors.playerName[0].messageTranslationKey, formErrors.playerName[0].variableToUseInMessage)
                        : undefined, id: 'new-player', label: players.length ? t('label.add_more_players') : t('label.add_players'), placeholder: t('placeholder.player_name'), value: formData.playerName, onChange: (event) => {
                        const { name, value } = event.target;
                        setFormData((prev) => ({ ...prev, [name]: value }));
                    }, additionalContent: _jsx("div", { className: 'player-control', children: _jsx(Button, { icon: _jsx(PlusIcon, {}), shape: 'square', iconSize: 'small', onClick: addPlayer }) }) }) }))] }));
};
export default GamePlayersModule;
